import { render, staticRenderFns } from "./creatProject.vue?vue&type=template&id=5709aa6e&scoped=true&"
import script from "./creatProject.vue?vue&type=script&lang=js&"
export * from "./creatProject.vue?vue&type=script&lang=js&"
import style0 from "./creatProject.vue?vue&type=style&index=0&id=5709aa6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709aa6e",
  null
  
)

export default component.exports